import request from '../../axios';

const PostFarmRequirement = async (payload: IFarmRequirementPayload) => {
  const newPayload = {
    title: payload.title,
    sub_input: payload.sub_input?.guid,
    location: `POINT (${payload.location?.lng} ${payload.location?.lat})`,
    il_type: payload.type || 'مشدی',
    brs_type: payload?.srs_type?.type,
    area: payload.area,
    area_unit: payload.area_unit?.value,
    only_massage_buyer: payload.only_massage_buyer || false,
    renting_duration: payload.renting_duration,
    renting_duration_unit: payload.renting_duration_unit?.value,
    is_change_title: payload?.is_change_title,
  };
  const res = await request.post(`api/v2/wanted/farm-requirement`, {
    ...newPayload,
  });

  return res.data;
};

export default PostFarmRequirement;
